import { observer, theme, ui } from "aaa";
import { InfoBoxWithBackground } from "components/common/InfoBoxWithBackground";
import { themeColors } from "muiTheme";
import * as React from "react";

export const JuniorInfoBox = observer(({ children, style }: { children: React.ReactNode, style?: React.CSSProperties }) => (
    <InfoBoxWithBackground
        borderColor={ui.isDarkMode ? themeColors.georgeBlue : themeColors.blue_200}
        borderWidth={2}
        borderRadius={theme.BORDER_RADIUS_LARGE}
        backgroundColor={ui.isDarkMode ? undefined : "#E7EFFD"}
        iconSize={16}
        iconColor={themeColors.georgeBlue}
        opacity={ui.isDarkMode ? undefined : 0.8}
        style={{
            ...style,
            color: ui.isDarkMode ? themeColors.grey_100 : themeColors.george_text_color,
        }}
    >
        {children}
    </InfoBoxWithBackground>
));


// WEBPACK FOOTER //
// ./src/components/gJunior/components/JuniorInfoBox.tsx